export default __webpack_public_path__ + "static/media/boost-01@2x.070a550b.jpg";